// extracted by mini-css-extract-plugin
module.exports = {"heading":"style_heading__167sh"};